"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _default = function _default() {
  return _react["default"].createElement(_uiKit.Icon, {
    name: "shootstagrad",
    size: 40,
    color: "black",
    spin: !0
  });
};

exports["default"] = _default;